import { RouterProvider } from 'react-router-dom';
import { router } from './lib/routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
}

export default App;